<template>
	<div class="type-writer">
		
		<div class="type-writer-head">
			<div class="head" :style="head_style">
				<div class="metal">
					<div class="left">
						<div class="lever">
							<div class="wrist"></div>
						</div>
						<div class="screw"></div>
					</div>
					<div class="right"></div>
				</div>
				<div class="opening">
					<transition name="paper" appear>
						<paper v-show="game.phases.length > 0" />
					</transition>
				</div>
			</div>
		</div>

		<div class="type-writer-socle">
			<div class="socle">
				<div class="socle-header">
					<div class="arc"></div>

					<div class="dots">
						<div class="dot"></div>
						<div class="dot"></div>
						<div class="dot"></div>
					</div>
				</div>
				<div class="socle-footer">
					
					<keyboard />

				</div>

			</div>
		</div>

	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import Keyboard from './Keyboard'
import Paper from './Paper'

export default {
	name: 'TypeWriter',
	data: function() {
		return {
			
		}
	},
	computed: Object.assign(mapGetters([ 'game' ]), {
		head_style: function() {
			var transform = 'translate3D(0, 48px, 0)'

			if (!this.game.first_time) {
				var x = 250 - (this.game.prompt.length * 16)
				transform = 'translate3D(' + x + 'px, 48px, 0)'
			}

			return { transform: transform }
		}
	}),
	mounted: function() {
		var that = this
		this.$store.dispatch('init')
		setTimeout(function() {
			that.$store.dispatch('start_game')
		}, 1000)
	},
	components: { Keyboard, Paper }
}
</script>

<style lang="stylus" scoped>
@import '../assets/css/app'

.type-writer
	display inline-block
	// position absolute
	// left 50%
	// bottom 40px
	// transform translate3D(-50%, 0, 0)
	width 740px
	.type-writer-head
		.head
			height 120px
			background dark
			box-shadow inset 0 -24px 0 0 darken(dark, 15%), 6px 12px 0 0 alpha(dark, 15%)
			border-radius 16px
			transition 0.25s easeOutQuart
			.metal
				height calc(100% - 24px)
				.left
					position absolute
					left -16px
					top calc(50% - 24px)
					height 64px
					width 16px
					background lightgray
					border-top-left-radius 8px
					border-bottom-left-radius 8px
					// overflow hidden
					&:before
						content ''
						position absolute
						top 0
						left 0
						right 0
						height 50%
						background darken(lightgray, 10%)
						border-top-left-radius 8px
					.screw
						position absolute
						top calc(50% - 16px)
						left -24px
						width 24px
						height 32px
						background darken(lightgray, 25%)
						border-top-left-radius 8px
						border-bottom-left-radius 8px
					.lever
						position absolute
						bottom 24px
						left -(16px + 4px)
						width 16px
						height 180px
						background darken(lightgray, 15%)
						border-top-left-radius 8px
						&:before
							content ''
							position absolute
							top 0
							left 0
							bottom 0
							width 50%
							background darken(lightgray, 10%)
							border-top-left-radius 8px
						.wrist
							position absolute
							top 0
							right -16px
							width 16px
							height 32px
							background darken(lightgray, 15%)
							border-top-right-radius 8px
							border-bottom-right-radius 8px
				.right
					position absolute
					right -16px
					top calc(50% - 24px)
					height 64px
					width 16px
					background lightgray
					border-top-right-radius 16px
					border-bottom-right-radius 16px
					overflow hidden
					box-shadow 6px 12px 0 0 alpha(dark, 15%)
					&:before
						content ''
						position absolute
						top 0
						left 0
						right 0
						height 50%
						background darken(lightgray, 10%)
			.opening
				position absolute
				left 32px
				right 32px
				top calc(50% - 24px)
				height 24px
				background darken(dark, 50%)
				border-radius 24px
				&:after
					content ''
					position absolute
					left 0
					right 0
					top 100%
					height 24px
					background dark
				.paper
					position absolute
					left 32px
					right 32px
					bottom 0px
	.type-writer-socle
		box-shadow 6px 12px 0 0 alpha(dark, 15%)
		border-radius 16px
		.socle
			.socle-header
				height 100px
				background lighten(red, 15%)
				border-top-left-radius 16px
				border-top-right-radius 16px
				box-shadow inset 0 8px 0 0 dark, 0 -2px 0 0 lighten(dark, 10%)
				.arc
					position absolute
					top 0
					left calc(50% - 80px)
					width 160px
					height 80px
					background dark
					border-bottom-left-radius 100%
					border-bottom-right-radius 100%
				.dots
					position absolute
					right 32px
					bottom 24px
					height 8px
					.dot
						display inline-block
						background red
						width 12px
						height 12px
						border-radius 16px
						box-shadow inset 0 2px 0 0 darken(red, 50%)
						background-color red
						&.full
							background dark
							background #C0CA33
			.socle-footer
				background red
				padding 16px 32px 56px 32px
				box-shadow inset 0 -40px 0 0 darken(red, 10%)
				border-bottom-left-radius 16px
				border-bottom-right-radius 16px
							
	
</style>



// WEBPACK FOOTER //
// src/components/TypeWriter.vue